module.exports = __webpack_public_path__ + "static/media/1417942302.520e0475.ttf";